import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PieChartBlock from '@/components/common/pie-chart-block/pie-chart-block';
import useGetDashboardCounterFormatQuestion198 from '@/hooks/useGetDashboardCounterFormatQuestion198';
import { Avatar } from '@/utils/types';

interface Props {
    title: string;
    leftLabel: string;
    rightLabel: string;
    interType: string;
    params: any;
    clientOrSite: 'client' | 'site' | 'place';
    avatar: Avatar;
}

const Dashboard = ({ rightLabel, leftLabel, title, interType, avatar }: Props) => {
    const rootId = typeof avatar.root === 'object' ? (avatar?.root?.id as string) : (avatar.id.split('/')[3] as string);

    const { value: firstValue, isLoading: isLoadingFirstValue } = useGetDashboardCounterFormatQuestion198({
        metadata_avatar_type__alphaId: 'big:type:intervention',
        node_name: 'PLANIFIÉE',
        interType,
        avatar_left: avatar.lft as number,
        avatar_level: avatar.lvl as number,
        avatar_right: avatar.rgt as number,
        avatar_root_id: rootId,
    });

    const { value: secondValue, isLoading: isLoadingSecondValue } = useGetDashboardCounterFormatQuestion198({
        metadata_avatar_type__alphaId: 'big:type:intervention',
        node_name: 'RÉALISÉE',
        interType,
        avatar_left: avatar.lft as number,
        avatar_level: avatar.lvl as number,
        avatar_right: avatar.rgt as number,
        avatar_root_id: rootId,
    });

    return (
        <Box
            sx={{
                display: 'grid',
                gap: 2,
                justifyContent: 'start',
                justifyItems: 'center',
            }}
        >
            <Typography
                sx={{
                    fontWeight: 700,
                }}
            >
                {title}
            </Typography>

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, auto)',
                    gap: 3,
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                        justifyItems: 'center',
                    }}
                >
                    <PieChartBlock
                        values={[firstValue, 0]}
                        isLoadingData={isLoadingFirstValue || isLoadingSecondValue}
                        onlyOne
                    />

                    <Typography
                        sx={{
                            fontWeight: 600,
                            color: '#505EB6',
                        }}
                    >
                        {leftLabel}
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                        justifyItems: 'center',
                    }}
                >
                    <PieChartBlock
                        values={[secondValue, firstValue + secondValue]}
                        isLoadingData={isLoadingFirstValue || isLoadingSecondValue}
                    />

                    <Typography
                        sx={{
                            fontWeight: 600,
                            color: '#505EB6',
                        }}
                    >
                        {rightLabel}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default Dashboard;
